import {
  USERS_BY_PROJECT_FETCH_STARTED,
  USERS_BY_PROJECT_FETCH_SUCCEEDED,
  USERS_BY_PROJECT_FETCH_FAILED
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchUsersByProject = projectId => async dispatch => {
  try {
    abortController.abort();
    const usersByProjectUrl = webPortalApi.buildApiUrl(`users?project=${projectId}`);
    dispatch({
      type: USERS_BY_PROJECT_FETCH_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    const res = await fetch(usersByProjectUrl, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }
    const projectUsers = await res.json();

    dispatch({
      type: USERS_BY_PROJECT_FETCH_SUCCEEDED,
      payload: { users: projectUsers, projectId }
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: USERS_BY_PROJECT_FETCH_FAILED,
      error: e
    });
  }
};
